<template>
  <div class="home" :style="$store.getters['customizer/getHomeStyles']">
    <div class="header" :style="$store.getters['customizer/getHeadlineTextStyles']">
      <div class="header__date-time" :style="$store.getters['customizer/getDateStyles']">
        <span v-if="$store.state.customizer.isShowDate && $store.state.customizer.isShowHeadline">{{ $store.getters.getHeaderDate(getLanguageDate) }}&nbsp;{{ $store.getters.getHeaderTime(getLanguageDate) }}</span>
        <span v-if="$store.state.customizer.isShowDate && !$store.state.customizer.isShowHeadline">{{ $store.getters.getHeaderDate(getLanguageDate) }}<br>{{ $store.getters.getHeaderTime(getLanguageDate) }}</span>
      </div>
      <div class="header__room" v-if="$store.state.customizer.isShowRoomHeader">
        {{ getRoomName }}: {{ $store.state.device.room }}
      </div>
      <div class="header__lang">
        <div class="header__lang-select-wrapper" :class="{ 'header__lang-select-wrapper--active': getIsFocusOnLang }" :style="getLangStyles(getIsFocusOnLang)">
          <img class="header__lang-icon" :src="getLanguageIcon" :style="$store.getters['customizer/getLangImgStyle']" />
          <div class="header__lang-name">{{ getLanguageName }}</div>
        </div>
      </div>
    </div>
    <div class="roomname" v-if="$store.state.customizer.isShowRoom" :style="$store.getters['customizer/getRoomnameTextStyles']">
        {{ getRoomName }} {{ $store.state.device.room }}
    </div>
    <div class="buildingname" v-if="$store.state.customizer.isShowBuilding" :style="$store.getters['customizer/getHotelnameTextStyles']">
        {{ $store.state.customizer.headline }}
    </div>
    <Navigation
      :menuItems="getMainMenu"
      :active-item-index="getActiveItemIndex"
      :is-active="getIsFocusOnNav"
    />
    <div v-if="osdVisible" class="osd-overlay">
      <div class="osd-content">
        {{ getChannelName }}: {{ osdChannel }}
      </div>
    </div>
  </div>
</template>

<script>
import router from '@/router';
import Navigation from '@/components/Navigation.vue';
import DeviceType from '@/helpers/DeviceType';
import Registration from '@/helpers/Registration';
import { keyHandler, KEYS } from '@/mixins/keyHandler';
import MediaHandler, { TYPE_IDENTIFIER } from '@/helpers/MediaHandler';
import i18n from '@/i18n';
import Device from '@/helpers/Device';
//import "core-js";

var pressedKey = 0;
var pressedInfoKey = [];
var timer = 0;
var maxChannelIndex = 0;

// Einmal pro App-Start pruefen, ob der Hotspot laufen muss. Modulweit, weil die
// Home-Seite bei jeder Navigation neu gemountet wird - und ein synchroner
// enableSoftAP-Aufruf pro Seitenwechsel waere genau das, was die App schon
// einmal einfrieren liess.
var hotspotChecked = false;

// Vorlauf, bevor der Hotspot-Aufruf losgeht: erst soll das Menue auf dem Schirm
// stehen. enableSoftAP ist synchron und haelt den Thread je Firmware bis zu
// zehn Sekunden.
var HOTSPOT_CHECK_DELAY_MS = 3000;

export default {
  mixins: [keyHandler],
  components: { Navigation },
  props: {
    bid: {
      type: Number | String,
      default: 56,
    },
    deviceId: {
      type: Number | String,
    },
    isActive: Boolean,
  },
  data() {
    return {
      keyStore: [],
      keyStoreTimer: 3000,
      keyStoreInterval: undefined,
      osdVisible: false,
      osdChannel: '',
      osdTimer: null,
    };
  },
  watch: {
    keyStore(value) {
      console.log('WATCH keyStore,', value);
      if (value.join('') === '220') {
        this.$store.dispatch('device/reboot');
      }
      if (value.join('') === '225') {
        // 220 startet das GERAET neu, 225 nur die SEITE - die Unterscheidung
        // bleibt absichtlich. Nur das Argument ist weg: reload(true) ist nicht
        // standardisiert und verhaelt sich auf aelteren WebKit-Builds
        // uneinheitlich. Bleibt die App danach weg, gilt hier dasselbe wie fuer
        // die Farbtastenfolge - dann ist 220 der verlaessliche Weg.
        //this.$store.dispatch('device/reboot');
        location.reload();
      }
      if (value.length > 0) {
        if (this.keyStoreInterval) {
          this.keyStoreTimer = 3000;
        } else {
          this.keyStoreHandler();
        }
      }
      // this.$store.dispatch('notification/new', {
      //   title: 'KeyStore',
      //   message: this.keyStore,
      // });
    },
    /*active(isActive) {
      if (isActive) this.$refs.input.focus();
      else this.$refs.input.blur();
    },*/
  },
  methods: {
    // Steht im Hauptmenue eine Cast-App, soll der Hotspot des TV laufen.
    //
    // Der Anlass: auf einem U800F war er aus, die Cast-Seite sagte es korrekt -
    // und sonst versuchte nichts mehr, ihn anzuschalten. Der Gast soll ihn aber
    // nicht erst durch das Oeffnen der Cast-Seite bekommen; steht die App im
    // Menue, gehoert der Hotspot an.
    //
    // Einmal pro App-Start, verzoegert und nur wenn er tatsaechlich aus ist:
    // enableSoftAP ist synchron und kann den Thread halten. Wiederholte
    // Versuche macht die Cast-Seite, wo eine Wartezeit sichtbar ist.
    ensureHotspotIfCastInMenu() {
      if (hotspotChecked) return;
      const menu = this.getMainMenu || [];
      const hasCast = menu.some(function(el) {
        return String((el && el.url) || '').toLowerCase().indexOf(TYPE_IDENTIFIER.CAST.toLowerCase()) !== -1;
      });
      // Kein Merker, wenn das Menue noch leer ist - dann greift der naechste
      // Aufruf der Home-Seite.
      if (!menu.length) return;
      hotspotChecked = true;
      if (!hasCast) return;
      setTimeout(() => {
        this.$store
          .dispatch('cast/ensureHotspot')
          .then((up) => {
            const state = up === true ? 'laeuft' : up === false ? 'aus' : 'keine Auskunft';
            console.log('[Home] Cast-App im Menue - Hotspot: ' + state);
          })
          .catch(() => {});
        // Und die Flags, ohne die der Hotspot allein nichts nuetzt.
        //
        // Am Geraet aufgetreten: nach einem Neustart verband sich das Handy
        // weiterhin mit dem SoftAP, aber die YouTube-App fand keinen Fernseher
        // mehr. Gefunden wird er ueber DIAL - und das lief bisher nur mit, wenn
        // jemand die Cast-Seite oeffnete (cast/prepare). Steht eine Cast-App im
        // Menue, gehoert beides an: der Hotspot UND die Auffindbarkeit.
        this.$store.dispatch('cast/ensureCastFlags').catch(() => {});
      }, HOTSPOT_CHECK_DELAY_MS);
    },
    keyStoreHandler() {
      this.keyStoreInterval = setInterval(() => {
        if (this.keyStoreTimer <= 0) {
          this.keyStore = [];
          clearInterval(this.keyStoreInterval);
          return;
        }
        this.keyStoreTimer -= 1000;
      }, 1000);
    },
    showOSD(channel) {
      this.osdChannel = channel;
      this.osdVisible = true;
      clearTimeout(this.osdTimer);
      this.osdTimer = setTimeout(() => {
        this.hideOSD();
      }, 5000);
    },
    hideOSD() {
      this.osdVisible = false;
      this.osdChannel = '';
      clearTimeout(this.osdTimer);
    },
    eventHandler(key, event) {
      //if(window.lgVersion === '3.5') {
        this.$store.dispatch('notification/new', {
          title: key,
          message: event,
        });
      //} else {
      //  this.$store.dispatch('notification/new', {
      //    title: key,
      //    message: JSON.stringify(event),
      //  });
      //}
      switch (key) {
        case KEYS.KEY_0:
        case KEYS.KEY_1:
        case KEYS.KEY_2:
        case KEYS.KEY_3:
        case KEYS.KEY_4:
        case KEYS.KEY_5:
        case KEYS.KEY_6:
        case KEYS.KEY_7:
        case KEYS.KEY_8:
        case KEYS.KEY_9:
          //this.keyStore.push(key);
          maxChannelIndex = this.$store.getters['tv/getChannelLength'] - 1;
          if(location.hash === '#/' || location.hash === '#/tv-player' || location.hash === '#/tv-player?origin=epg') {
            if(parseInt(pressedKey) > 0) {
              pressedKey = pressedKey + key;
              if(timer) {
                clearTimeout(timer);
                timer = 0;
              }
            }else if(parseInt(pressedKey) > 9) {
              pressedKey = pressedKey + key;
              if(timer) {
                clearTimeout(timer);
                timer = 0;
              }
            } else {
              pressedKey = key;
            }
            this.showOSD(pressedKey);
            /*if (timer) {
              clearTimeout(timer);
            }*/
            timer = setTimeout(() => {
              let startChannel = {
                "index": parseInt(pressedKey)-1,
              }
              pressedKey = 0;
              if(startChannel.index <= maxChannelIndex && startChannel.index >= 0) {
                this.$store.commit('tv/setChannelIndex', startChannel.index , { root: true });
                this.$store.commit('tv/setTargetIndex', startChannel.index , { root: true });
                this.$router.push({
                  name: 'TVPlayer',
                });
              }
              this.hideOSD();
            }, 1250);
          }
          // this.$store.dispatch('notification/new', { title: key });
          this.keyStore.push(key);
          break;
        case KEYS.RIGHT:
          if (this.getIsFocusOnNav)
            this.$store.dispatch('navigation/mainMenuGoRight');
          break;
        case KEYS.LEFT:
          if (this.getIsFocusOnNav)
            this.$store.dispatch('navigation/mainMenuGoLeft');
          break;
        case KEYS.DOWN:
          if (!this.getIsFocusOnNav) {
            this.$store.dispatch('navigation/selectLanguage');
          }
          break;
        case KEYS.UP:
          if (!this.getIsFocusOnLang) {
            this.$store.dispatch('navigation/selectLanguage');
          }
          // this.$store.dispatch('customizer/fetchCustomizerSettings', 56);
          break;
        case KEYS.RED:
        case KEYS.GREEN:
        case KEYS.YELLOW:
        case KEYS.BLUE:
          //console.log("================KEYS.INFO", pressedInfoKey);
          if(key === KEYS.RED) {
            pressedInfoKey["1"] = key;
            if(timer) {
              clearTimeout(timer);
              timer = 0;
            }
          }
          if(key === KEYS.GREEN && pressedInfoKey["1"] === KEYS.RED) {
            pressedInfoKey["2"] = key;
            if(timer) {
              clearTimeout(timer);
              timer = 0;
            }
          }
          if(key === KEYS.YELLOW && pressedInfoKey["2"] === KEYS.GREEN) {
            pressedInfoKey["3"] = key;
            if(timer) {
              clearTimeout(timer);
              timer = 0;
            }
          }
          if(key === KEYS.BLUE && pressedInfoKey["3"] === KEYS.YELLOW) {
            pressedInfoKey["4"] = key;
            if(timer) {
              clearTimeout(timer);
              timer = 0;
            }
          }
          if(pressedInfoKey["4"] === KEYS.BLUE) {
            pressedInfoKey["5"] = key;
            if(timer) {
              clearTimeout(timer);
              timer = 0;
            }
          }
          /*if(pressedInfoKey["5"] != KEYS.BLUE) {
            pressedInfoKey["6"] = key;
            if(timer) {
              clearTimeout(timer);
              timer = 0;
            }
          }*/
          timer = setTimeout(() => {
            //console.log("+++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++KEY", pressedInfoKey);
            if(pressedInfoKey["1"] === KEYS.RED && pressedInfoKey["2"] === KEYS.GREEN && pressedInfoKey["3"] === KEYS.YELLOW && pressedInfoKey["4"] === KEYS.BLUE) {
              switch(pressedInfoKey["5"]) {
                case KEYS.RED:
                  //if(!pressedInfoKey["6"]) {
                    pressedInfoKey = [];
                    this.$router.push({
                      name: 'Info',
                    });
                  //}
                  break;
                case KEYS.GREEN:
                  // Geraete-Neustart - genau das, was der Befehl "Neu starten"
                  // im SocketAdmin macht und was dort nachweislich funktioniert:
                  //   experienceEvent {action: reboot} -> device/reboot
                  //     -> Device.reboot() -> rebootDevice
                  //
                  // Hier stand vorher ein location.reload(). Danach kam die App
                  // nicht zurueck, und diagnostizierbar war es nicht: der
                  // Fern-Logger steckt im App-Bundle und schweigt, solange die
                  // App nicht laeuft - Stillstand und stiller Fehlschlag sehen
                  // dort gleich aus. Ein Geraete-Neustart nimmt stattdessen den
                  // Weg, den die Firmware kennt; die WGT startet danach ohnehin
                  // frisch, liest build.json neu und laedt die aktuellen Bundles.
                  //
                  // Der Cache-Zeiger wird bewusst NICHT mehr geloescht: der
                  // SocketAdmin-Weg tut es auch nicht, und ohne ihn haette der TV
                  // keinen Rueckfall, falls build.json nach dem Neustart einmal
                  // nicht erreichbar ist.
                  pressedInfoKey = [];
                  console.log('[Home] Farbtastenfolge: Geraete-Neustart');
                  this.$store.dispatch('device/reboot');
                  break;
                case KEYS.YELLOW:
                  //console.log("++++++++++++++++++++++++++++++++++++++++++++++++++++YELLOW", pressedInfoKey["5"]);
                  //if(pressedInfoKey["6"] === KEYS.BLUE) {
                  //  console.log("++++++++++++++++++++++++++++++++++++++++++++++++++++RED", pressedInfoKey["6"]);
                    pressedInfoKey = [];
                    this.handleDeleteStorageData();
                    //Registration.removeData();
                  //} else if(pressedInfoKey["6"] != KEYS.BLUE) {
                  //  pressedInfoKey = [];
                  //}
                  break;
                default:
              }
            }
          }, 1000);
          break;
        case KEYS.ENTER:
          this.$store.dispatch('navigation/callMainMenu');
          break;
        case KEYS.BACK:
        default:
          console.log('KEY NOT SUPPORTED', key);
      }
    },

    handleEnterMenu() {
      const element = this.getMainMenu[this.getActiveItemIndex];
      // Browser-App: eigene Kennung, geprueft VOR dem iframe. Die Adresse geht
      // an den Browser des Geraets, die App bleibt unbelastet.
      if (element.url.toLowerCase().includes(TYPE_IDENTIFIER.BROWSER.toLowerCase())) {
        this.$store.dispatch(
          'navigation/openInBrowser',
          MediaHandler.stripIdentifier(element.url, TYPE_IDENTIFIER.BROWSER)
        );
        return;
      }
      const isIframe = element.url.includes('iFrame');
      if (isIframe) {
        router.push(MediaHandler.assembleWebsiteQuery(element));
        return;
      }
      switch (element.type) {
        default:
          this.$store.dispatch('notification/new', {
            title: 'Not supported Type: ' + element.type,
            message: 'This feature is currently not supported',
          });
          console.log(element);
      }
    },
    callbackShowWindow(context) {
      console.log('context', context);
    },
    handleDeleteStorageData() {
      Registration.removeData();
      Registration.removeCookie();
    },
    getLangStyles(isActive) {
      const colorStyles = this.$store.getters['customizer/getLangStyle'](
        isActive
      );

      return {
        ...colorStyles,
      };
    },
  },
  computed: {
    getMainMenu() {
      return this.$store.getters['navigation/getMainMenu'];
    },
    getActiveItemIndex() {
      return this.$store.state.navigation.mainMenuSelectedItemIndex;
    },
    getIsFocusOnNav() {
      return !this.$store.getters['navigation/getIsLanguageSelected'];
    },
    getIsFocusOnLang() {
      return this.$store.getters['navigation/getIsLanguageSelected'];
    },
    getLanguage() {
      return this.$store.getters['lang/getActiveLang'];
    },
    getLanguageIcon() {
      // getLanguage kann null sein, wenn die Sprache im Customizer nicht verfuegbar ist
      return (this.getLanguage && this.getLanguage.icon) || this.$store.state.lang.icon;
    },
    getLangIdentifier() {
      return this.$store.getters['lang/getLang'];
    },
    getLanguageEntry() {
      // Fallback auf Default (Englisch), falls der Code in i18n nicht existiert
      return i18n[this.getLangIdentifier] || i18n[this.$store.state.lang.default] || {};
    },
    getLanguageName() {
      const entry = this.getLanguageEntry;
      return entry.language ? entry.language.name : '';
    },
    getLanguageDate() {
      return this.getLanguageEntry.dateISO || 'en-GB';
    },
    getRoomName() {
      //console.log("------------------------HCAP", hcap.property.getPictureProperty({"key": hcap.property.PicturePropertyKey.ASPECT_RATIO}));
      //console.log("------------------------HOME-MAC", DeviceType.getMAC);
      //console.log("------------------------HOME-IP", DeviceType.getIP);
      //console.log("========================ROOM-getDeviceType", DeviceType.getDeviceType);
      console.log("========================ROOM-isLG", DeviceType.isLG, window.lgVersion);
      console.log("========================ROOM-isTizen", DeviceType.isTizen);
      console.log("========================ROOM-isOrsay", DeviceType.isOrsay);
      console.log("========================ROOM-isRPI", DeviceType.isRPI);
      return this.$i18n('room.name');
    },
    getChannelName() {
      return this.$i18n('channel.name');
    },
    getTextStyles(state, getters, rootState, rootGetters) {
      const values = rootGetters['customizer/getWelcomeValues'];
      return {
        color: values.welcomeTextColor,
        backgroundColor: values.welcomeDetailActiveBackgroundColor,
      };
    },
  },
  mounted() {
    this.$store.dispatch('tv/kill');
    this.ensureHotspotIfCastInMenu();
    // Hier wird bewusst kein EPG mehr vorgeladen.
    // Die Kanalliste braucht zwei Dinge, und beide kommen inzwischen ohne den
    // TV-Guide: die Logos aus tv/prepare (fetchAllEPGData), die Jetzt-/Danach-
    // Daten aus epgNow - beides angestossen von navigation/init. Der Guide
    // selbst laedt beim Oeffnen (v1 in EPGGuide.init, v2 gedrosselt in
    // epgGuide2/init) und muss dafuer nicht am HOME-Start haengen.
  },
};
</script>

<style scoped>
.home {
  background-size: cover;
  box-sizing: border-box;
  display: flex;
  flex-direction: column-reverse;
  /* justify-content: space-between; */
  height: 100vh;
  overflow: hidden;
  padding: 60px 90px;
  position: relative;
  width: 100vw;

  /*backdrop-filter: blur(20px);*/
}

.osd-overlay {
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  background-color: rgba(0, 0, 0, 0.7);
  padding: 10px;
  z-index: 1000;
}

.osd-content {
  color: white;
  font-size: 24px;
  text-align: center;
}

.roomname {
  align-items: center;
  background: transparent;
  /*word-wrap: break-word;*/
  /*color: white;*/
  overflow: hidden;
  white-space: nowrap;
  font-weight: bold;
  font-size: 7vh;
  display: flex;
  height: 7vh;
  justify-content: space-between;
  left: 52vw;
  position: absolute;
  padding: 0 0.5vh;
  top: 20vh;
  width: 100%;
}
.buildingname {
  align-items: center;
  background: transparent;
  /*word-wrap: break-word;*/
  /*color: white;*/
  /* font-weight: bold; */
  overflow: hidden;
  white-space: nowrap;
  font-size: 6vh;
  display: flex;
  height: 7vh;
  justify-content: space-between;
  left: 52vw;
  position: absolute;
  padding: 0 0.5vh;
  top: 30vh;
  width: 100%;
}
.header {
  align-items: center;
  /*background: linear-gradient(
    180deg,
    rgba(0, 0, 0, 1),
    rgba(0, 0, 0, 0.8) 95%,
    transparent
  );*/
  background-color:black;
  color: white;
  /* font-weight: bold; */
  font-size: 3vh;
  display: flex;
  height: 6vh;
  justify-content: space-between;
  left: 0;
  position: absolute;
  padding: 0 0.5vh;
  top: 0;
  width: 100%;
}

.header__room {
  flex: 0 0 30%;
  text-align: left;
  overflow: hidden;
  white-space: nowrap;
}
.header__date-time {
  flex: 0 0 52%;
  padding-left: 1vh;
}

.header__date-time {
  text-align: left;
}

.header__lang {
  flex: 0 0 18%;
  align-items: center;
  display: flex;
  justify-content: flex-end;
}
.header__lang-select-wrapper {
  align-items: center;
  border: 0.3vh solid transparent;
  display: flex;
  padding: 0.15vh 0.8vw;
}
.header__lang-icon {
  margin-right: 1vh;
  max-height: 2.5vh;
}
.header__lang-select-wrapper--active {
  border-color: #f1f1f1;
}

.header__date-time {
  text-align: left;
}

</style>



// WEBPACK FOOTER //
// src/pages/Home.vue